import React, { useEffect, useRef } from "react";
import { Modal } from "react-bootstrap";
import { Button, Col, FormGroup, Input, Label } from "reactstrap";
import { Formik } from "formik";
import * as Yup from "yup";
import DatePicker from "react-datepicker";
import CustomReactSelect from "../../../components/CustomReactSelect";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ItemRequisitionAPI } from "../ItemRequisitionAPI";
import axios from "axios";
import { UserConsumer } from "../../../UserContext";
import { AlertPopups } from "../../../components/AlertPopups";

function VendorPopupModal(props) {
	const {
		showModal,
		isEditMode,
		onClose,
		categoryId,
		itemRequisitionId,
		vendorTobeEditedId,
		vendorByCategoryList,
		setVendorByCategoryList,
		selectedVendor,
		setSelectedVendor,
		onVendorChange,
		unitPrice,
		onUnitPriceChange,
		quantity,
		onQuantityChange,
		totalCost,
		description,
		onDescriptionChange,
		delieveryTime,
		setDelieveryTime,
		recommended,
		setRecommended,
		clearFormValues,
	} = props;

	let token = null;
	const initialValues = {
		name: selectedVendor?.label,
		unitPrice: unitPrice,
		quantity: quantity,
		totalCost: totalCost,
	};
	const DatepickerRef = useRef(null);

	const validate = Yup.object().shape({
		name: Yup.string()
			.required("Select Name")
			.typeError("Invalid input")
			.nullable(),
		unitPrice: Yup.string()
			.required("Price is required")
			.typeError("Invalid input"),
		quantity: Yup.string()
			.required("Description is required")
			.typeError("Invalid input"),
	});

	useEffect(() => {
		//get vendor name on basis of category
		axios
			.get(
				`${ItemRequisitionAPI.GetVendorByCategoryId}/${categoryId}/Vendors`,
				{
					headers: {
						Authorization: `Bearer ${token}`,
					},
				}
			)
			.then(({ status, data }) => {
				if (status === 200) {
					if (isEditMode)
						setSelectedVendor(
							data.vendorList.find(
								(item) =>
									item.label.toLowerCase() ===
									selectedVendor.toLowerCase()
							)
						);
					else
						setSelectedVendor(
							data.vendorList.sort((a, b) =>
								a.label.localeCompare(b.label)
							)[0]
						);

					setVendorByCategoryList(data.vendorList);
				}
			});
	}, [isEditMode]);

	const handleSubmit = () => {
		const formData = {
			vendor: selectedVendor?.value,
			categoryId: categoryId,
			unitPrice: unitPrice,
			quantity: quantity,
			totalCost: totalCost,
			description: description,
			delieveryTime: delieveryTime,
			recommended: recommended,
		};
		if (isEditMode) {
			// update vendor Quotation
			axios
				.put(
					`${ItemRequisitionAPI.PutVendorQuotations}/${itemRequisitionId}/VendorQuotations/${vendorTobeEditedId}`,
					formData,
					{
						headers: {
							Authorization: `Bearer ${token}`,
						},
					}
				)
				.then(({ status, message }) => {
					if (status === 200) {
						AlertPopups.successAlert.fire({
							text: "Vendor Updated",
						});
						window.location.reload();
					} else if (status === 400) {
						AlertPopups.ErrorAlert.fire({
							text: message,
						});
					}
				})
				.catch((error) => {
					if (error.response)
						AlertPopups.ErrorAlert.fire({
							text: error.response.data.message,
						});
					else
						AlertPopups.ErrorAlert.fire({
							text: "Server Error",
						});
				});
			onClose();
		} // Create New vendor Quotation
		else {
			axios
				.post(
					`${ItemRequisitionAPI.PostVendorQuotations}/${itemRequisitionId}/VendorQuotations`,
					formData,
					{
						headers: {
							Authorization: `Bearer ${token}`,
						},
					}
				)
				.then(({ status, message }) => {
					if (status === 200) {
						AlertPopups.successAlert.fire({
							text: "Vendor Added",
						});
						window.location.reload();
					} else if (status === 400) {
						AlertPopups.ErrorAlert.fire({
							text: message,
						});
					}
				})
				.catch((error) => {
					if (error.response)
						AlertPopups.ErrorAlert.fire({
							text: error.response.data.message,
						});
					else
						AlertPopups.ErrorAlert.fire({
							text: "Server Error",
						});
				});
		}
		onClose();
	};

	const openDatepicker = () => {
		const datepickerElement = DatepickerRef.current;
		datepickerElement.setFocus(true);
	};
	return (
		<UserConsumer>
			{(userDetails) => {
				token = userDetails.token;
				return (
					<Modal size="lg" show={showModal}>
						<Modal.Body className="p-0">
							<Formik
								enableReinitialize={true}
								initialValues={initialValues}
								validationSchema={validate}
								validateOnChange={true}
								onSubmit={() => handleSubmit()}
							>
								{({ errors, handleSubmit }) => (
									<form
										onSubmit={handleSubmit}
										className="itemReqPopupForm"
									>
										<FormGroup
											row
											id="row0"
											className="bottom-spacing topBorders  "
										>
											<Label sm={11}>
												Vendor Quotations Form
											</Label>
											<Col
												sm={1}
												className="d-flex"
												style={{
													justifyContent: "flex-end",
												}}
											>
												<button
													type="button"
													class="close"
													onClick={onClose}
													style={{ color: "white" }}
												>
													<span aria-hidden="true">
														×
													</span>
													<span class="sr-only">
														Close
													</span>
												</button>
											</Col>
										</FormGroup>
										<FormGroup
											row
											className="bottom-spacing rowStyle1"
										>
											<Label
												for="title"
												sm={3}
												md={3}
												lg={3}
											>
												Name{" "}
												<span className="required">
													*
												</span>
											</Label>
											<Col sm={9} md={9} lg={9}>
												<CustomReactSelect
													options={vendorByCategoryList.sort(
														(a, b) =>
															a.label.localeCompare(
																b.label
															)
													)}
													value={selectedVendor}
													onChange={(value) =>
														onVendorChange(value)
													}
													className={`formValueInput description ${
														errors.name
															? "h-auto invalid"
															: "h-auto"
													}`}
												/>
											</Col>
										</FormGroup>
										<FormGroup
											row
											className="bottom-spacing rowStyle2"
										>
											<Label
												for="title"
												sm={3}
												md={3}
												lg={3}
											>
												Unit Price{" "}
												<span className="required">
													*
												</span>
											</Label>
											<Col>
												<Input
													type="number"
													value={unitPrice}
													onChange={(event) => {
														onUnitPriceChange(
															event.target.value
														);
													}}
													className={`formValueInput ${
														errors.unitPrice
															? "h-auto invalid"
															: "h-auto"
													}`}
												/>
											</Col>
											<Label
												for="selectPriority"
												sm={3}
												md={3}
												lg={3}
											>
												Quantity{" "}
												<span className="required">
													*
												</span>
											</Label>
											<Col>
												<Input
													type="number"
													value={quantity}
													onChange={(event) => {
														onQuantityChange(
															event.target.value
														);
													}}
													className={`formValueInput ${
														errors.quantity
															? "h-auto invalid"
															: "h-auto"
													}`}
												/>
											</Col>
										</FormGroup>
										<FormGroup
											row
											className="bottom-spacing rowStyle1"
										>
											<Label
												for="Description"
												sm={3}
												md={3}
												lg={3}
											>
												Total Cost
											</Label>
											<Col sm={9} md={9} lg={9}>
												{totalCost}
											</Col>
										</FormGroup>
										<FormGroup
											row
											className="bottom-spacing rowStyle2"
										>
											<Label
												for="Description"
												sm={3}
												md={3}
												lg={3}
											>
												Description
											</Label>
											<Col sm={9} md={9} lg={9}>
												<Input
													type="textarea"
													maxLength="400"
													value={description}
													onChange={(value) =>
														onDescriptionChange(
															value
														)
													}
													style={{
														font: "13px Poppins",
													}}
												/>
											</Col>
										</FormGroup>
										<FormGroup
											row
											className="bottom-spacing rowStyle1"
										>
											<Label
												for="Description"
												sm={3}
												md={3}
												lg={3}
											>
												Delievery Time
											</Label>
											<Col className="datepicker-wrapper">
												<DatePicker
													showYearDropdown
													showMonthDropdown
													dateFormatCalendar=" " //for title
													name="delieveryTime"
													className="custom-container"
													selected={delieveryTime}
													onChange={(value) =>
														setDelieveryTime(value)
													}
													autoComplete="off"
													dateFormat="dd/MM/yyyy"
													ref={DatepickerRef}
												/>
												<FontAwesomeIcon
													icon={faCalendarAlt}
													className="calender-icon"
													color="keppel"
													onClick={() =>
														openDatepicker()
													}
												/>
											</Col>
											<Label
												for="Description"
												sm={3}
												md={3}
												lg={3}
											>
												Recommended
											</Label>
											<Col>
												<input
													className="checkboxInput"
													type="checkbox"
													checked={recommended}
													onChange={(event) => {
														setRecommended(
															!recommended
														);
													}}
												/>
											</Col>
										</FormGroup>
										<div className="btns">
											{isEditMode ? (
												<>
													<Button
														className="submit-btn leftBtn"
														onClick={handleSubmit}
													>
														Update
													</Button>
													<Button
														className="reset-btn"
														onClick={
															clearFormValues
														}
													>
														Reset
													</Button>
												</>
											) : (
												<Button
													className="submit-btn leftBtn"
													onClick={handleSubmit}
												>
													Submit
												</Button>
											)}
										</div>
									</form>
								)}
							</Formik>
						</Modal.Body>
					</Modal>
				);
			}}
		</UserConsumer>
	);
}

export default VendorPopupModal;
